import 'semantic-ui-css/semantic.min.css'
import { React } from 'react';
import {
  useNavigate
} from "react-router-dom";
import classNames from 'classnames';
import styles from './css/Item.css';
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import { Card , Label , Image , Icon , Popup } from 'semantic-ui-react';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';
import useWindowDimensions from './useWindowDimensions'


const icons = {
    E_BOOK : 'book',
    E_TIJDSCHRIFT : 'address book',
    WEBSITE : 'globe',
    E_DATABANK : 'computer',
    E_HANDBOEK : 'book',
    KRANT : 'newspaper',
    E_PLATFORM : 'keyboard',
    E_DOCUMENT : 'file',
    MULTIMEDIA : 'play'
}

const pjson = require('../package.json')
const base = (!!pjson.homepage) ? pjson.homepage : '/'

const  EpubItem = ({ item }) => {
    const navigate = useNavigate()
    const link = base + 'detail/' + item.id
    const {height, width} = useWindowDimensions();

    const { t , i18n } = useTranslation();
        return (

        <Card
            onClick={() => navigate(link) }
            className={classNames(
                styles.itemCard,
            )}
            style={{
                margin : '3px'
            }}
        fluid
        key={`epub_${item.id}`}
        >
            
        {item.uitgelicht && (
            <Label
                icon='hand point right outline'
                className={styles.label}
                content={t('uitgelicht')}
                color='teal'
            />
        )}
            <Card.Content
                header={item.titel}
                description={item.uitgever}
            /> 
        {item.afbeelding !== null && (
            <Image src={item.afbeelding} wrapped size={width > 1150 ? 'medium' : 'tiny'} key={`img_${item.id}`} />
        )}
        <Label
            className={styles.label}
        >
            {item.uitgavenvorm.map(( k , v) => {
                return <Popup content={t(`taxonomieItems.${k}`)} trigger={<Icon circular inverted name={icons[k]} color='blue' alt={t(`taxonomieItems.${k}`)} />} />
            })
            }
        </Label>
    </Card>
    );

}

export default EpubItem;